/* eslint-disable no-extra-parens */
import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

const navbarStyles = css`
    position: sticky;
    top: 0;
    z-index: 99;
    width: 100%;

    .menu-icon {
        display: none;
    }

    .nav-items {
        display: flex;
        flex-direction: row;
        top: 0;
        background-color: lightgray;
        width: 100%;
        .nav-item {
            padding: 0.4rem 2rem;
        }
    }

    @media screen and (max-width: ${(widgetStyles.themeVars as { [k: string]: string })[
            '$window-max-width-mobile'
        ]}) {
        .menu-icon {
            display: flex;
            position: relative;
            top: 0;
            border: none;
            cursor: pointer;
            outline: none;
            float: left;
        }

        .nav-items {
            display: none;
            .nav-item {
                padding: 0.4rem 1rem;
            }
        }

        .show-menu {
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 1.5rem;
        }
    }
`;

export const themeNavbarStyles = css`
    position: sticky;
    top: 0;
    z-index: 99;
    width: 100%;

    .menu-icon {
        display: none;
    }

    .nav-items {
        display: flex;
        flex-direction: row;
        top: 0;
        background-color: var(--color-light-grey);
        width: 100%;

        .nav-item {
            padding: 0.4rem 2rem;
            font-size: var(--body-fontSize);
        }
    }

    @media screen and (max-width: ${(widgetStyles.themeVars as { [k: string]: string })[
            '$window-max-width-mobile'
        ]}) {
        .menu-icon {
            display: flex;
            position: relative;
            top: 0;
            border: none;
            cursor: pointer;
            outline: none;
            float: left;
        }

        .nav-items {
            display: none;
            .nav-item {
                padding: 0.4rem 1rem;
            }
        }

        .show-menu {
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 1.5rem;
        }
    }
`;

export default navbarStyles;
